module.exports = __webpack_public_path__ + "img/10-1_06.748bd89e.jpg";